document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.our-courses-gallery');
    blocks.forEach(initializeCoursesGallery);
});

function initializeCoursesGallery(block) {
    const form = block.querySelector('form');
    const inputs = [...form.elements];
    const courses = block.querySelectorAll('.course-card');
    const sectors = block.querySelectorAll('.sector-container');
    const noFound = block.querySelector('.nofound-text');

    const filterPosts = () => {
        const params = inputs
            .map((inp) => [inp.getAttribute('data-name'), inp.value])
            .filter(
                ([name, value]) =>
                    name !== null && value !== null && value !== '',
            );

        let hasMatches = false;
        courses.forEach((course) => {
            let hide = false;
            for (const [key, value] of params) {
                const courseValue =
                    course.getAttribute('data-' + key)?.toLowerCase() ?? '';
                if (!courseValue.includes(value.toLowerCase())) {
                    hide = true;
                    break;
                }
            }
            if (!hide) hasMatches = true;
            course.parentElement.toggleAttribute('hidden', hide);
        });

        // Check if sector has any visible courses
        sectors.forEach((sector) => {
            let visible = false;
            sector.querySelectorAll('.course-card').forEach((course) => {
                if (!course.parentElement.hasAttribute('hidden')) {
                    visible = true;
                }
            });
            sector.toggleAttribute('hidden', !visible);
        });

        noFound.toggleAttribute('hidden', hasMatches);

        // Commented out, because updating the filters on the page, doesn't query for additional posts.
        // So it is possible to apply filters, refresh (only relevant posts are loaded for query params),
        // then filters do not bring in new matching posts.
        //
        // Update url params with orinal input names
        // const urlParams = inputs.reduce((acc, inp) => {
        //     const name = inp.getAttribute('name');
        //     if (name && inp.value !== null && inp.value !== '') {
        //         acc.set(name, inp.value);
        //     }
        //     return acc;
        // }, new URLSearchParams());

        // window.history.replaceState(
        //     {},
        //     '',
        //     `${window.location.pathname}?${urlParams.toString()}`,
        // );
    };

    const filterPostsWrapper = (e) => {
        e.preventDefault();
        filterPosts();
    };

    for (const inp of inputs) {
        inp.addEventListener('input', filterPostsWrapper);
    }
    form.addEventListener('submit', (e) => e.preventDefault());
}

const cardFilterGalleries = document.querySelectorAll('.card-filter-gallery');

document.addEventListener('DOMContentLoaded', function () {
    cardFilterGalleries.forEach((gallery) => {
        const searchInput = gallery.querySelector('input[name="course_name"]');
        const courseCards = gallery.querySelectorAll('.course-card');

        function filterCourses() {
            const searchQuery = searchInput.value.toLowerCase();

            courseCards.forEach(function (card) {
                const courseName = card.getAttribute('data-name').toLowerCase();

                if (courseName.includes(searchQuery)) {
                    jQuery(card).parent().fadeIn();
                } else {
                    jQuery(card).parent().fadeOut();
                }
            });
        }

        const debouncedFilterCourses = debounce(filterCourses, 300);

        searchInput.addEventListener('input', debouncedFilterCourses);
    });
});

export function debounce(func, delay) {
    let timeout;
    return function () {
        const context = this,
            args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}
